
import {
  defineComponent, PropType, ref, computed,
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import { BOTTOM_POPUP_TYPES, MEDIA_TYPES, SHARE_SETTINGS } from '@/types/enums';
import { ICase } from '@/types/interfaces';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';
import useHeaderBooleans from '@/composables/UseHeaderBooleans';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  props: {
    iCase: { type: Object as PropType<ICase>, required: true },
  },
  emits: ['close', 'openMovePopUp', 'deleteCase', 'saveCaseAsCopy', 'removeSharing', 'open-reorder-photo', 'openRenamePopUp', 'onShare'],
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const currentCase = ref(props.iCase);

    const isCaseDeleting = ref(false);

    const isMy = computed(() => currentCase.value?.owner?.accountId === mainStore.user.accountId);
    const allowSave = computed(() => isMy.value
      || (currentCase.value.root && currentCase.value.shareSettings?.includes(SHARE_SETTINGS.ALLOW_SAVE)));
    const isNetwork = computed(() => route.meta.isNetwork);

    const photoUploading = computed(() => mainStore.mediaUploading);

    const showUnSharingMenu = computed(() => {
      const cid = currentCase.value?.id;
      if (!cid) return false;
      return driveStore.networkCases.data.filter((el) => el.id === cid)[0].unShareable || false;
    });

    const { actionBar } = useHeaderBooleans();

    function hidePopUp() {
      emit('close');
    }

    function editCase() {
      hidePopUp();
      emit('openRenamePopUp');
    }

    function openMovePopUp() {
      emit('openMovePopUp');
    }

    function openInfoPopUp() {
      emit('close');
      mainStore.BottomPopUpType = BOTTOM_POPUP_TYPES.CASE_INFO;
    }

    function deleteCase() {
      emit('deleteCase');
    }

    function saveCaseAsCopy() {
      emit('saveCaseAsCopy');
    }

    function removeSharing() {
      emit('removeSharing');
    }

    return {
      editCase,
      deleteCase,
      saveCaseAsCopy,
      hidePopUp,
      openMovePopUp,
      openInfoPopUp,
      removeSharing,
      isCaseDeleting,
      router,
      MEDIA_TYPES,
      isNetwork,
      isMy,
      showUnSharingMenu,
      actionBar,
      photoUploading,
      allowSave,
    };
  },
});
